import Axios from 'axios';
import { Configuration } from './configuration';
import { LoginApiFactory, UserApiFactory, DocumentApiFactory, DocumentSoort } from './api';

// Configure the api without a basepath as we are using a proxy to the api.
const basePath = '/ssa';

const config: Configuration = {
  basePath: basePath,
  isJsonMime: function (mime: string): boolean {
    return (new Configuration()).isJsonMime(mime);
  }
};

// Export the configured api instances.
export const loginApi = LoginApiFactory(config, basePath, Axios);

export const userApi = UserApiFactory(config, basePath, Axios);

export const documentApi = DocumentApiFactory(config, basePath, Axios);

export const downloadDmsDocumentPath = (placetID: string, documentSoort?: DocumentSoort) =>
  `/ssa/api/Document/getDocument/${placetID}?documentSoort=${documentSoort}`;

export const downloadDocument = (documentId: number, filename: string) =>
    `/ssa/api/Document/downloadDocument/${documentId}?filename=${filename}`;
